(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog-slider"] && !Shopify.designMode) return;
  try {
    
  new Splide('.featured-blog', {
    type: 'slide',
    perPage: 3,
    perMove: 1,
    pagination: false,
    gap: "10px",
    breakpoints: {
      992: {
        perPage: 2,
        gap: "15px"
      },
      749: {
        perPage: 1
      },
    }
  }).mount();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oz-instagram-post-slider"] && !Shopify.designMode) return;
  try {
    
  new Splide('.instagram-slider', {
    type: 'slide',
    perPage: 3,
    perMove: 1,
    pagination: true,
    breakpoints: {
      992: {
        perPage: 2,
      },
      749: {
        type: 'loop',
        gap: "10px",
        perPage: 1,
        padding: "20px"
      },
    }
  }).mount();

  } catch(e) { console.error(e); }
})();
})();
